/* ==========================================================================
   lpf.js — Verhalten der Herbst-Landingpages 2026 und der Beratungsformulare.
   Wird von mehreren Sections eingebunden; der Wächter unten sorgt dafür, dass
   alles nur einmal läuft.

   Enthält:
   - Tracking (GA4 per gtag, GTM per dataLayer, Meta-Pixel, Clarity, HubSpot)
   - Video-Steuerung (stumm abspielen im Sichtfeld, Ton-Knopf, Lightbox)
   - Countdown bis zu einem echten Enddatum
   - Mehrstufiges Beratungs-Formular (Video oder Telefon, erreichbar morgens/mittags/abends)
   ========================================================================== */
(function () {
  'use strict';
  if (window.LPF && window.LPF.__ready) return;
  var LPF = window.LPF = window.LPF || {};
  LPF.__ready = true;

  var PHONE_LABEL = '056 511 27 55';
  var WA_LINK = 'https://wa.me/41772892931';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function uid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'lpf-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ---------------- Tracking ---------------- */
  // GA4 direkt per gtag, GTM über eigene lpf_*-Ereignisse im dataLayer (keine
  // Doppelzählung: GTM-Trigger müssen die lpf_-Namen bewusst aufgreifen).
  LPF.track = function (evt, params) {
    params = params || {};
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'lpf_' + evt }, params)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', evt === 'lead' ? 'generate_lead' : 'lpf_' + evt, params); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', 'lpf_' + evt); } catch (e) {}
  };
  (function tagClarity() {
    var el = $('[data-lpf-page]');
    if (!el) return;
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'lp_slug', el.getAttribute('data-lpf-page') || '');
        window.clarity('set', 'lp_angle', el.getAttribute('data-lpf-angle') || '');
      }
    } catch (e) {}
  })();

  /* ---------------- Sichtbarkeits-Animation ---------------- */
  var rvObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rvObs.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveal(root) {
    $$('.lpf-rv', root).forEach(function (el) { if (rvObs) rvObs.observe(el); else el.classList.add('is-in'); });
  }

  /* ---------------- Videos ---------------- */
  var vObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.35) {
        if (v.dataset.lpfManual === '1') return;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: [0, 0.35, 0.6] }) : null;

  function muteOthers(except) {
    $$('.lpf-vbox.is-sound').forEach(function (b) {
      if (b === except) return;
      var v = $('video', b); if (v) v.muted = true;
      b.classList.remove('is-sound');
    });
  }
  // Datensparmodus, langsames Netz oder «weniger Bewegung»: nur Standbilder, kein Autoplay
  function lowData() {
    try {
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)2g$|^3g$/.test(c.effectiveType || ''))) return true;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    } catch (e) {}
    return false;
  }
  // Hero-Video erst nach dem Seitenaufbau, damit Text, Bilder und Formular zuerst laden
  function afterLoad(fn) {
    if (document.readyState === 'complete') { setTimeout(fn, 150); return; }
    var done = false;
    var go = function () { if (done) return; done = true; fn(); };
    window.addEventListener('load', go, { once: true });
    setTimeout(go, 3000);
  }
  function initVideos(root) {
    // Sichtbar erst, wenn wirklich Bilder laufen — bis dahin zeigt das Vorschaubild
    $$('.lpf-vbox video, video.lpf-hero__v', root).forEach(function (v) {
      if (v.__lpfp) return; v.__lpfp = 1;
      v.addEventListener('playing', function () { v.classList.add('is-ready'); var b = v.closest('.lpf-vbox'); if (b) b.classList.add('is-playing'); });
    });
    // Abgeleitete 720p-Fassung fehlt? Dann auf die 1080p-Fassung zurück (data-fb)
    $$('video source[data-fb]', root).forEach(function (s) {
      if (s.__lpffb) return; s.__lpffb = 1;
      s.addEventListener('error', function () {
        var fb = s.getAttribute('data-fb'), v = s.parentNode;
        if (!fb || s.getAttribute('src') === fb || !v) return;
        s.setAttribute('src', fb); v.load();
        var r = v.getBoundingClientRect();
        if (v.hasAttribute('data-lpf-auto') && r.bottom > 0 && r.top < window.innerHeight) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    var slow = lowData();
    $$('video[data-lpf-auto]', root).forEach(function (v) {
      if (v.__lpf) return; v.__lpf = 1;
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.playsInline = true;
      if (!vObs || slow) return;
      if (v.hasAttribute('data-lpf-hero')) afterLoad(function () { vObs.observe(v); });
      else vObs.observe(v);
    });
    $$('.lpf-vbox__snd', root).forEach(function (b) {
      if (b.__lpf) return; b.__lpf = 1;
      b.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var box = b.closest('.lpf-vbox'); var v = box && $('video', box); if (!v) return;
        var on = !box.classList.contains('is-sound');
        if (on) { muteOthers(box); v.muted = false; if (v.dataset.lpfRestart === '1') { try { v.currentTime = 0; } catch (e) {} } var p = v.play(); if (p && p.catch) p.catch(function () {}); box.classList.add('is-sound', 'is-playing'); LPF.track('video_sound', { video: v.dataset.lpfName || '' }); }
        else { v.muted = true; box.classList.remove('is-sound'); }
      });
    });
    $$('.lpf-vbox__play', root).forEach(function (b) {
      if (b.__lpf) return; b.__lpf = 1;
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var box = b.closest('.lpf-vbox'); var v = box && $('video', box); if (!v) return;
        muteOthers(box); v.dataset.lpfManual = '1'; v.muted = false; v.controls = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        box.classList.add('is-playing', 'is-sound');
        LPF.track('video_play', { video: v.dataset.lpfName || '' });
      });
    });
    $$('[data-lpf-lb]', root).forEach(function (el) {
      if (el.__lpf) return; el.__lpf = 1;
      el.addEventListener('click', function (ev) { ev.preventDefault(); openLb(el.getAttribute('data-lpf-lb'), el.hasAttribute('data-lpf-wide'), el.getAttribute('data-lpf-name') || '', el.getAttribute('data-lpf-lb-fb') || ''); });
    });
  }
  var lb;
  function openLb(src, wide, name, fb) {
    if (!src) return;
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'lpf-lb lpf-scope'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<div class="lpf-lb__in"><button type="button" class="lpf-lb__x" aria-label="Schliessen">&times;</button><video controls playsinline></video></div>';
      document.body.appendChild(lb);
      var close = function () { var v = $('video', lb); v.pause(); v.removeAttribute('src'); v.load(); lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lpf-lb__x')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
    }
    muteOthers(null);
    $$('video[data-lpf-auto]').forEach(function (v) { v.pause(); });
    $('.lpf-lb__in', lb).classList.toggle('is-wide', !!wide);
    var v = $('video', lb); v.src = src; v.muted = false;
    v.onerror = function () { if (!lb.classList.contains('is-open')) return; if (fb && v.getAttribute('src') !== fb) { v.src = fb; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); } };
    lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    LPF.track('video_play', { video: name, mode: 'lightbox' });
  }

  /* ---------------- Countdown ---------------- */
  // Akzeptiert ISO-Datum oder Unix-Sekunden (Liquid: | date: '%s')
  function toMs(v) { if (!v) return 0; v = String(v).trim(); return /^\d+$/.test(v) ? parseInt(v, 10) * 1000 : Date.parse(v); }
  function initCountdowns(root) {
    var els = $$('[data-lpf-cd]', root).filter(function (el) { return !el.__lpf; });
    var daysEls = $$('[data-lpf-days-left]', root);
    if (!els.length && !daysEls.length) return;
    els.forEach(function (el) { el.__lpf = 1; });
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var end = toMs(el.getAttribute('data-lpf-cd'));
        if (!end) return;
        var d = Math.max(0, end - now);
        var s = Math.floor(d / 1000);
        var u = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        $$('[data-u]', el).forEach(function (n) { var k = n.getAttribute('data-u'); var t = String(k === 'd' ? u.d : pad(u[k])); if (n.textContent !== t) n.textContent = t; });
        var inline = $('[data-lpf-cd-inline]', el);
        if (inline) { var it = (u.d > 0 ? u.d + ' T ' : '') + pad(u.h) + ':' + pad(u.m) + ':' + pad(u.s); if (inline.textContent !== it) inline.textContent = it; }
        if (d <= 0) {
          var scope = el.closest('[data-lpf-cd-scope]') || el;
          scope.setAttribute('hidden', '');
          $$('[data-lpf-hide-ended]').forEach(function (x) { x.setAttribute('hidden', ''); });
        }
      });
      daysEls.forEach(function (el) {
        var end = toMs(el.getAttribute('data-lpf-days-left'));
        if (!end) return;
        var days = Math.ceil((end - now) / 86400000);
        var dt = String(Math.max(0, days)); if (el.textContent !== dt) el.textContent = dt;
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- Sprungmarken zum Formular ---------------- */
  function initGoto(root) {
    $$('[data-lpf-goto]', root).forEach(function (a) {
      if (a.__lpf) return; a.__lpf = 1;
      a.addEventListener('click', function (ev) {
        var gid = a.getAttribute('data-lpf-goto') || '';
        var target = document.getElementById(gid) || (gid ? document.querySelector('[id$="' + gid.replace(/"/g, '') + '"]') : null) || $('.lpf-form');
        if (!target) return;
        ev.preventDefault();
        // Spa-Leadformular (lead-form-advanced) ist zugeklappt: beim Sprung aufklappen
        var tgl = target.querySelector && target.querySelector('[id$="-toggle"]'), bdy = target.querySelector && target.querySelector('[id$="-body"]');
        if (tgl && bdy && !bdy.classList.contains('open')) { try { tgl.click(); } catch (e) {} }  // zugeklappt = ohne Klasse «open» (max-height 0)
        var form = target.classList.contains('lpf-form') ? target : $('.lpf-form', target) || target;
        var pi = a.getAttribute('data-lpf-interest') || '', pp = a.getAttribute('data-lpf-product') || '';
        if (form.__lpfApi && (pi || pp)) form.__lpfApi.preset(pi, pp);
        var y = form.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
        LPF.track('cta_click', { cta: a.getAttribute('data-lpf-cta') || a.textContent.trim().slice(0, 40), lp_slug: (form.dataset || {}).lpSlug || '' });
      });
    });
    $$('[data-lpf-cta]:not([data-lpf-goto])', root).forEach(function (a) {
      if (a.__lpfc) return; a.__lpfc = 1;
      a.addEventListener('click', function () { LPF.track('cta_click', { cta: a.getAttribute('data-lpf-cta') }); });
    });
  }

  /* ==========================================================================
     Formular
     ========================================================================== */
  var INTEREST_LABEL = { pergola: 'Pergola mit Lamellendach', wintergarten: 'Wintergarten mit Glaswänden', beschattung: 'Beschattung / SkyShade', zubehoer: 'Seitenwände, Glas und Zubehör', beratung: 'Noch offen, Beratung gewünscht' };

  function Form(el) {
    this.el = el;
    this.d = el.dataset;
    this.steps = $$('.lpf-step', el).filter(function (s) { return !s.hasAttribute('data-skip'); });
    $$('.lpf-step[data-skip]', el).forEach(function (s) { s.parentNode.removeChild(s); });
    this.i = 0;
    this.t0 = Date.now();
    this.started = false;
    this.eventId = uid();
    this.bind();
    this.show(0, true);
    var self = this;
    el.__lpfApi = { preset: function (interest, product) { self.preset(interest, product); } };
  }
  Form.prototype.ctx = function () {
    return { lp_slug: this.d.lpSlug || '', lp_angle: this.d.lpAngle || '', form_position: this.d.position || '', page_type: this.d.pageType || 'lp', product: this.d.productTitle || '' };
  };
  Form.prototype.bind = function () {
    var self = this, el = this.el;
    // data-auto ohne Wert = jede Auswahl führt weiter; mit Wert = nur diese Gruppe
    function autoFor(step, name) {
      if (!step.hasAttribute('data-auto')) return false;
      var g = step.getAttribute('data-auto');
      return !g || g === name;
    }
    function scheduleNext(step) {
      if (self._pending) return;
      self._pending = setTimeout(function () { self._pending = null; if (self.steps[self.i] === step) self.next(); }, 240);
    }
    el.addEventListener('change', function (e) {
      var t = e.target;
      if (!self.started) { self.started = true; LPF.track('form_start', self.ctx()); }
      if (t.name === 'beratungsart') { self.modeUi(); LPF.track('beratungsart', Object.assign({ beratungsart: t.value }, self.ctx())); }
      if (t.type === 'radio') {
        var step = t.closest('.lpf-step');
        if (step && autoFor(step, t.name)) scheduleNext(step);
      }
    });
    // Klick auf eine bereits gewählte Kachel (z. B. vorbelegt) führt ebenfalls weiter
    el.addEventListener('click', function (e) {
      var tile = e.target.closest && e.target.closest('.lpf-tile'); if (!tile) return;
      var inp = tile.querySelector('input'); var step = tile.closest('.lpf-step');
      if (inp && inp.checked && step && autoFor(step, inp.name)) {
        if (!self.started) { self.started = true; LPF.track('form_start', self.ctx()); }
        scheduleNext(step);
      }
    });
    el.addEventListener('input', function (e) {
      if (!self.started) { self.started = true; LPF.track('form_start', self.ctx()); }
      if (e.target.getAttribute('aria-invalid') === 'true') { e.target.removeAttribute('aria-invalid'); var er = e.target.parentNode.querySelector('.lpf-err'); if (er) er.textContent = ''; }
    });
    $$('[data-lpf-next]', el).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); self.next(); }); });
    $$('[data-lpf-back]', el).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); self.show(Math.max(0, self.i - 1)); }); });
    $$('[data-lpf-tel]', el).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); var r = $('input[name="beratungsart"][value="telefon"]', el); if (r) { r.checked = true; self.modeUi(); LPF.track('cal_alt_telefon', self.ctx()); } }); });
    var more = $('[data-lpf-more]', el);
    if (more) more.addEventListener('click', function (e) { e.preventDefault(); var f = $('[data-lpf-msg]', el); if (f) { f.hidden = false; more.hidden = true; var ta = $('textarea', f); if (ta) ta.focus(); } });
    el.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
  };
  /* ----- Videoberatung: Cal.com-Kalender direkt im Formular ----- */
  var CAL_LINK = 'team/spa-solutions-skypergola/video-beratung-sky-pergola';
  function calLoader() {
    (function (C, A, L) { var p = function (a, ar) { a.q.push(ar); }; var d = C.document; C.Cal = C.Cal || function () { var cal = C.Cal; var ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement('script')).src = A; cal.loaded = true; } if (ar[0] === L) { var api = function () { p(api, arguments); }; var namespace = ar[1]; api.q = api.q || []; if (typeof namespace === 'string') { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ['initNamespace', namespace]); } else p(cal, ar); return; } p(cal, ar); }; })(window, 'https://app.cal.com/embed/embed.js', 'init');
  }
  Form.prototype.mode = function () {
    var r = $('input[name="beratungsart"]:checked', this.el);
    return r ? r.value : 'video';
  };
  Form.prototype.modeUi = function () {
    var video = this.mode() === 'video';
    var kz = $('[data-lpf-kz]', this.el), cw = $('[data-lpf-cal-wrap]', this.el);
    if (kz) kz.hidden = video;
    if (cw) cw.hidden = !video;
    var st = this.steps[this.i];
    if (video && st && st.getAttribute('data-step') === 'callback') this.showCal();
  };
  Form.prototype.calNotes = function () {
    var p = this.payload();
    var FL = { bis_12: 'bis 12 m²', '12_24': '12 bis 24 m²', '24_40': '24 bis 40 m²', ueber_40: 'über 40 m²', unklar: 'noch unklar' };
    var ZE = { innerhalb_1_monat: 'innert 1 Monat', '1_3_monate': 'in 1 bis 3 Monaten', '3_6_monate': 'in 3 bis 6 Monaten', '6_12_monate': 'in 6 bis 12 Monaten', spaeter_12_monate: 'später als 12 Monate' };
    return ['Interesse: ' + (p.product_title || p.interest_label || '-'), 'Fläche: ' + (FL[p.flaeche] || '-'), 'Umsetzung: ' + (ZE[p.umsetzungszeitraum] || '-'), 'Seite: ' + (p.lp_slug || location.pathname) + ' (' + (p.form_position || '-') + ')'].join(' | ');
  };
  Form.prototype.showCal = function () {
    if (this.calOn) return;
    var box = $('[data-lpf-cal]', this.el);
    if (!box) return;
    this.calOn = true;
    var self = this;
    calLoader();
    var ns = 'lpf' + (this.d.formId || 'form').replace(/[^a-z0-9]/gi, '');
    var cfg = this.calConfig();
    window.Cal('init', ns, { origin: 'https://app.cal.com' });
    var api = window.Cal.ns[ns];
    api('inline', { elementOrSelector: '#' + box.id, config: cfg, calLink: CAL_LINK });
    api('ui', { theme: 'light', hideEventTypeDetails: true, layout: 'month_view', styles: { branding: { brandColor: '#b8965a' } }, cssVarsPerTheme: { light: { 'cal-brand': '#b8965a' } } });
    api('on', { action: 'linkReady', callback: function () { box.classList.add('is-ready'); LPF.track('cal_loaded', self.ctx()); } });
    var onBooked = function (e) { self.calBooked(e && e.detail && e.detail.data); };
    api('on', { action: 'bookingSuccessful', callback: onBooked });
    api('on', { action: 'bookingSuccessfulV2', callback: onBooked });
    api('on', { action: 'linkFailed', callback: function () { self.calFailed(); } });
    LPF.track('cal_open', this.ctx());
  };
  // Herkunft wie attribution-capture: URL zuerst, sonst Cookie sp_attr (l/f = UTMs ohne «utm_», k = Klick-IDs)
  function spAttr() {
    try { var m = document.cookie.match(/(?:^|; )sp_attr=([^;]*)/); return m ? JSON.parse(decodeURIComponent(m[1])) : {}; } catch (e) { return {}; }
  }
  Form.prototype.calConfig = function () {
    var p = this.payload();
    var q = new URLSearchParams(location.search), at = spAttr(), touch = at.l || at.f || {}, clicks = at.k || {};
    // Pflichtfeld «Worum geht es in diesem Termin?» (title) vorbefüllen, damit Kunden weniger tippen
    var cfg = { layout: 'month_view', theme: 'light', notes: this.calNotes(), beratersprache: 'Deutsch', title: ('Videoberatung: ' + (p.product_title || p.interest_label || 'Pergola')).slice(0, 120) };
    // Versteckte Buchungsfelder des Events (utm_*, Klick-IDs) — die Termin-Sync schreibt sie nach HubSpot
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = q.get(k) || touch[k.slice(4)]; if (v) cfg[k] = String(v).slice(0, 250); });
    var CLK = { gclid: 'g', fbclid: 'f', msclkid: 'm', wbraid: 'w', gbraid: 'b' };
    Object.keys(CLK).forEach(function (k) { var v = q.get(k) || clicks[CLK[k]]; if (v) cfg[k] = String(v).slice(0, 400); });
    // Buchungsfragen aus den Formular-Antworten vorbefüllen (Optionswerte exakt wie im Event)
    var G = { bis_12: 'ca. 3 x 3 m', '12_24': 'ca. 4 x 4 m', '24_40': 'ca. 4 x 6 m', ueber_40: 'Grösser / Sondermass', unklar: 'Weiss ich noch nicht' };
    var Z = { innerhalb_1_monat: 'So schnell wie möglich', '1_3_monate': 'In 1-3 Monaten', '3_6_monate': 'In 3-6 Monaten', spaeter_12_monate: 'Ich informiere mich erst' };
    if (G[p.flaeche]) cfg.groesse = G[p.flaeche];
    if (Z[p.umsetzungszeitraum]) cfg.zeitrahmen = Z[p.umsetzungszeitraum];
    // Seiten-Kennung als Buchungs-Metadaten (landen im Webhook unter payload.metadata)
    cfg['metadata[lp_slug]'] = this.d.lpSlug || '';
    cfg['metadata[lp_angle]'] = this.d.lpAngle || '';
    cfg['metadata[form_position]'] = this.d.position || '';
    cfg['metadata[engine]'] = 'lpf_form_video';
    cfg['metadata[event_id]'] = this.eventId;
    var utk = cookie('hubspotutk'); if (utk) cfg['metadata[hubspotutk]'] = utk;
    return cfg;
  };
  Form.prototype.calFailed = function () {
    var r = $('input[name="beratungsart"][value="telefon"]', this.el);
    if (r) { r.checked = true; this.modeUi(); }
    this.flash(this.steps[this.i], 'Der Kalender lädt gerade nicht. Wähle einfach, wann wir dich anrufen dürfen.');
    LPF.track('cal_failed', this.ctx());
  };
  Form.prototype.calBooked = function (data) {
    if (this.booked) return;
    this.booked = true;
    var p = this.payload(), ctx = this.ctx();
    var uid = (data && (data.uid || (data.booking && data.booking.uid))) || '';
    LPF.track('cal_booked', Object.assign({ cal_uid: uid, event_id: p.event_id }, ctx));
    LPF.track('lead', Object.assign({}, ctx, { method: 'cal_video', interest: p.interest, flaeche: p.flaeche, umsetzungszeitraum: p.umsetzungszeitraum, beratungsart: 'video', kontaktzeit: 'termin', event_id: p.event_id, currency: 'CHF', value: 1 }));
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: p.lp_slug || p.product_handle, content_category: p.lp_angle || p.page_type }, { eventID: p.event_id });
        window.fbq('track', 'Schedule', { content_name: 'lpf_form_video' }, { eventID: p.event_id + '-sch' });
      }
    } catch (e) {}
    this.el.classList.add('is-done', 'is-booked');
    var r = this.el.getBoundingClientRect();
    if (r.top < 0) window.scrollTo({ top: r.top + window.pageYOffset - 90, behavior: 'smooth' });
    try { sessionStorage.setItem('lpf_lead_done', '1'); } catch (e) {}
  };
  Form.prototype.preset = function (interest, product) {
    var r = interest ? $('input[name="interest"][value="' + interest + '"]', this.el) : null;
    if (r) { r.checked = true; if (this.steps[this.i] && this.steps[this.i].getAttribute('data-step') === 'interest') this.next(); }
    if (product) { var h = $('input[name="product_title"]', this.el); if (h) h.value = product; }
  };
  Form.prototype.show = function (i, silent) {
    var self = this;
    this.i = i;
    this.steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    var n = this.steps.length;
    $$('.lpf-prog i', this.el).forEach(function (b, k) { b.classList.toggle('is-on', k <= i); b.style.display = k < n ? '' : 'none'; });
    var txt = $('.lpf-prog__txt', this.el);
    if (txt) txt.innerHTML = '<span>Schritt ' + (i + 1) + ' von ' + n + '</span><span>' + (this.steps[i].getAttribute('data-label') || '') + '</span>';
    var st = this.steps[i];
    $$('[data-lpf-back]', st).forEach(function (b) { b.style.visibility = i === 0 ? 'hidden' : ''; });
    if (st.getAttribute('data-step') === 'callback') this.modeUi();
    if (!silent) {
      LPF.track('form_step', Object.assign({ step_index: i + 1, step_name: st.getAttribute('data-step') }, this.ctx()));
      var r = this.el.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: r.top + window.pageYOffset - 90, behavior: 'smooth' });
      var f = $('input:not([type="hidden"]):not([type="radio"]), textarea', st);
      if (f && window.innerWidth > 800) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
  };
  Form.prototype.valid = function (st) {
    var name = st.getAttribute('data-step');
    var names = [];
    $$('input[type="radio"]', st).forEach(function (r) { if (names.indexOf(r.name) === -1) names.push(r.name); });
    for (var k = 0; k < names.length; k++) {
      if (!$('input[name="' + names[k] + '"]:checked', st)) {
        this.flash(st, name === 'callback' ? 'Bitte wähle, wann wir dich am besten erreichen.' : 'Bitte wähle eine Antwort.');
        return false;
      }
    }
    return true;
  };
  Form.prototype.flash = function (st, msg) {
    var h = $('.lpf-hint--err', st) || $('.lpf-hint', st);
    if (h) { h.textContent = msg; h.classList.add('is-err'); }
  };
  Form.prototype.next = function () {
    var st = this.steps[this.i];
    if (!this.valid(st)) return;
    if (this.i < this.steps.length - 1) this.show(this.i + 1);
  };

  /* ----- Kontaktangaben prüfen ----- */
  Form.prototype.checkContact = function () {
    var el = this.el, ok = true, first = null;
    function bad(input, msg) {
      input.setAttribute('aria-invalid', 'true');
      var er = input.parentNode.querySelector('.lpf-err'); if (er) er.textContent = msg;
      if (!first) first = input; ok = false;
    }
    var fn = $('input[name="first_name"]', el), ln = $('input[name="last_name"]', el), em = $('input[name="email"]', el), ph = $('input[name="phone"]', el), zip = $('input[name="postal_code"]', el);
    if (fn && fn.value.trim().length < 2) bad(fn, 'Bitte deinen Vornamen.');
    if (ln && ln.value.trim().length < 2) bad(ln, 'Bitte deinen Nachnamen.');
    if (em && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim())) bad(em, 'Bitte eine gültige E-Mail-Adresse.');
    if (ph) { var digits = ph.value.replace(/\D/g, ''); if (digits.length < 9 || digits.length > 15) bad(ph, 'Bitte eine gültige Telefonnummer, z. B. 079 123 45 67.'); }
    if (zip && zip.hasAttribute('required') && !/^\d{4,5}$/.test(zip.value.trim())) bad(zip, 'Bitte deine Postleitzahl (4 Ziffern).');
    if (first) first.focus();
    return ok;
  };

  Form.prototype.payload = function () {
    var el = this.el, d = this.d, fd = {};
    $$('input, textarea', el).forEach(function (i) {
      if (!i.name) return;
      if ((i.type === 'radio' || i.type === 'checkbox') && !i.checked) return;
      fd[i.name] = (i.value || '').trim();
    });
    var qsp = new URLSearchParams(location.search);
    var KZ = { vormittags: 'morgens (8 bis 12 Uhr)', nachmittags: 'mittags (12 bis 17 Uhr)', abends: 'abends (17 bis 19 Uhr)', asap: 'so schnell wie möglich' };
    var art = fd.beratungsart === 'telefon' ? 'Telefon' : 'Videoberatung';
    var kzv = fd.kontaktzeit || 'asap';
    var p = {
      form_version: 'lpf-2', form_id: d.formId || '', event_id: this.eventId,
      lp_slug: d.lpSlug || '', lp_angle: d.lpAngle || '', lp_variant: d.lpVariant || '', form_position: d.position || '', page_type: d.pageType || 'lp',
      product_handle: d.productHandle || '', product_title: fd.product_title || d.productTitle || '',
      interest: fd.interest || d.interest || '', interest_label: INTEREST_LABEL[fd.interest || d.interest] || '',
      flaeche: fd.flaeche || '', umsetzungszeitraum: fd.umsetzungszeitraum || '',
      beratungsart: fd.beratungsart || 'video', kontaktzeit: kzv === 'asap' ? '' : kzv, kontaktzeit_label: KZ[kzv] || '',
      callback_label: art + ', ' + (KZ[kzv] || 'so schnell wie möglich'),
      first_name: fd.first_name || '', last_name: fd.last_name || '', name: ((fd.first_name || '') + ' ' + (fd.last_name || '')).trim(),
      email: (fd.email || '').toLowerCase(), phone: fd.phone || '', postal_code: fd.postal_code || '', message: fd.message || '',
      quelle: d.pageType === 'pdp' ? 'Formular Produktseite' : 'Formular Landingpage', engine: 'lpf_callback',
      hubspotutk: cookie('hubspotutk'), page_url: location.href, referrer: document.referrer || '',
      locale: (document.documentElement.lang || 'de'), market: (window.Shopify && window.Shopify.country) || '',
      ttc_s: Math.round((Date.now() - this.t0) / 1000), hp: fd.lpf_hp || ''
    };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'msclkid', 'ttclid', 'wbraid', 'gbraid'].forEach(function (k) { var v = qsp.get(k); if (v) p[k] = v.slice(0, 250); });
    return p;
  };

  Form.prototype.submit = function () {
    var self = this, el = this.el;
    var st = this.steps[this.i];
    if (st.getAttribute('data-step') !== 'contact') { this.next(); return; }
    if (!this.checkContact()) return;
    var btn = $('button[type="submit"]', el), alertEl = $('.lpf-alert', el);
    if (btn.getAttribute('data-busy') === 'true') return;
    btn.setAttribute('data-busy', 'true'); btn.disabled = true; alertEl.classList.remove('is-on');
    var p = this.payload();
    var ctx = this.ctx();
    // Honeypot oder Klick-Roboter: Erfolg anzeigen, nichts senden
    if (p.hp || p.ttc_s < 4) { setTimeout(function () { self.done(p); }, 600); return; }
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
    fetch(el.getAttribute('data-endpoint'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { clearTimeout(timer); return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || (res.j && res.j.status === 'error')) throw new Error((res.j && res.j.message) || 'http');
        self.done(p);
        var conv = Object.assign({}, ctx, { interest: p.interest, flaeche: p.flaeche, umsetzungszeitraum: p.umsetzungszeitraum, beratungsart: p.beratungsart, kontaktzeit: p.kontaktzeit || 'asap', event_id: p.event_id, currency: 'CHF', value: 1 });
        LPF.track('lead', conv);
        try {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'Lead', { content_name: p.lp_slug || p.product_handle, content_category: p.lp_angle || p.page_type }, { eventID: p.event_id });
            window.fbq('trackCustom', 'ProductEnquiryFormSubmitted', { content_name: p.lp_slug || p.product_handle, lp_angle: p.lp_angle, form_position: p.form_position }, { eventID: p.event_id + '-pefs' });
          }
        } catch (e) {}
        try { window._hsq = window._hsq || []; window._hsq.push(['identify', { email: p.email, firstname: p.first_name, lastname: p.last_name }]); window._hsq.push(['trackPageView']); } catch (e) {}
      })
      .catch(function () {
        btn.removeAttribute('data-busy'); btn.disabled = false;
        alertEl.innerHTML = 'Das hat leider nicht geklappt. Bitte versuche es nochmals — oder ruf uns direkt an: <a href="tel:+41565112755">' + PHONE_LABEL + '</a> · <a href="' + WA_LINK + '" target="_blank" rel="noopener">WhatsApp</a>';
        alertEl.classList.add('is-on');
        LPF.track('form_error', ctx);
      });
  };

  Form.prototype.done = function (p) {
    var el = this.el;
    var slotEl = $('.lpf-done__slot', el);
    if (slotEl) {
      slotEl.textContent = '';
      var add = function (tag, txt) { var n = document.createElement(tag); n.textContent = txt; slotEl.appendChild(n); };
      add('small', 'Deine Wahl');
      add('b', p.callback_label.charAt(0).toUpperCase() + p.callback_label.slice(1));
      add('small', 'Wir melden uns bei ' + p.phone);
    }
    var nm = $('[data-lpf-name]', el); if (nm) nm.textContent = p.first_name;
    el.classList.add('is-done');
    var r = el.getBoundingClientRect();
    if (r.top < 0) window.scrollTo({ top: r.top + window.pageYOffset - 90, behavior: 'smooth' });
    try { sessionStorage.setItem('lpf_lead_done', '1'); } catch (e) {}
  };

  function initForms(root) {
    $$('form.lpf-form', root).forEach(function (el) { if (!el.__lpfApi) new Form(el); });
  }

  /* ---------------- Start ---------------- */
  function init(root) {
    initReveal(root); initVideos(root); initCountdowns(root); initGoto(root); initForms(root);
  }
  LPF.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
